export default {
  title: {
    id: 'bo_sellers-orders-drawers-import_csv_file-modal_title',
    defaultMessage: 'Import CSV file',
  },
  submit: {
    id: 'bo_sellers-orders-drawers-import_csv_file-import_file',
    defaultMessage: 'Import file',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-import_csv_file-cancel',
    defaultMessage: 'Cancel',
  },
  back: {
    id: 'bo_sellers-orders-drawers-import_csv_file-back',
    defaultMessage: 'Back',
  },
  fileImportSuccessTitle: {
    id: 'bo_sellers-orders-drawers-import_csv_file-file_imported',
    defaultMessage: 'File imported',
  },
  fileImportSuccessDescription: {
    id: 'bo_sellers-orders-drawers-import_csv_file-see_details',
    defaultMessage: 'See details in the File Library',
  },
  importTrackingNumbersTitle: {
    id: 'bo_sellers-orders-drawers-import_csv_file-import_tracking_numbers_title',
    defaultMessage: 'Import tracking numbers',
  },
  importIMEIsTitle: {
    id: 'bo_sellers-orders-drawers-import_csv_file-import_imeis_title',
    defaultMessage: 'Import IMEIs',
  },
} as const
